export default __webpack_public_path__ + "static/media/pencilEditIcon.aad00d63.PNG";